import React, { useEffect, useState } from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading } from "components/misc/Headings.js";
import logo from "../../images/tabebek-logo.png";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";
import aptBook from "images/apt-book.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import i18next, { t } from "i18next";
import i18n from "i18n";
import eradahLogo from "images/assests/eradah-logo.jpg";
import { ReactComponent as FacebookIcon } from "../../images/facebook-icon.svg";
import { ReactComponent as TwitterIcon } from "../../images/twitter-icon.svg";
import { ReactComponent as InstagramIcon } from "../../images/instagram-icon.svg";
import { ReactComponent as TikTokIcon } from "../../images/tiktok-icon.svg";

import { ReactComponent as ArrowLeft } from "../../images/arrow-left-3-icon.svg";
import { ReactComponent as ArrowRight } from "../../images/arrow-right-3-icon.svg";

const Container = tw.div`relative`;
const TwoColumn = tw.div`flex flex-col md:flex-row justify-between max-w-screen-xl mx-6 md:mx-auto mb-12 pt-32`;
const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-5/12 flex-shrink-0 md:h-auto pt-0 md:pt-32`;
const TextColumn = styled(Column)((props) => [
  tw`md:w-7/12 mt-16 md:mt-0`,
  props.textOnLeft
    ? tw`md:mx-12 lg:mr-16 md:order-first`
    : tw`md:ml-12 lg:ml-16 md:order-last`,
]);

const Image = styled.div((props) => [
  `background-image: url("${props.imageSrc}");`,
  tw`rounded bg-contain bg-no-repeat bg-center h-32 md:h-72 lg:h-96`,
]);
const TextContent = tw.div``;

export const Heading = styled(SectionHeading)`
  ${tw`mt-4 font-black text-3xl sm:text-4xl lg:text-5xl leading-tight`};
  span {
    ${tw`text-primary-500`}
  }
`;

const SubHeading = tw.div`
mt-4 font-black text-xl sm:text-2xl lg:text-3xl`;
const Description = tw.p`mt-4 text-sm md:text-base lg:text-lg font-medium leading-relaxed text-secondary-100`;

const Form = tw.form`mt-8 md:mt-10 text-sm flex flex-col max-w-lg mx-auto md:mx-0`;
const Input = tw.input`mt-6 first:mt-0 border-b-2 py-3 focus:outline-none font-medium transition duration-300 hocus:border-primary-500`;

const SubmitButton = tw(PrimaryButtonBase)`inline-block mt-8`;
const LangButton = tw(
  PrimaryButtonBase
)`flex justify-center text-base w-24 h-8 p-0`;
const Header = tw.header`fixed z-20 top-0
 flex justify-center items-center
  w-full mx-auto bg-white h-24
`;
export const DesktopNavLinks = tw.nav`
  bg-white w-11/12 3xl:w-1/2 py-2 
`;
export const NavLink = tw.a`
text-lg my-2 lg:text-sm lg:mx-6 lg:my-0
font-semibold tracking-wide transition duration-300
pb-1 border-b-2 border-transparent 
`;
export const LogoLink = styled(NavLink)`
  ${tw`flex justify-between items-center font-black border-b-0 text-2xl! ml-0!`};
  img {
    ${tw`w-40`}
  }
`;

const SocialLinksContainer = tw.div`mt-4 text-center`;
const SocialLink = styled.a`
  ${tw`cursor-pointer inline-block p-2 rounded-full bg-gray-700 text-gray-100 hover:bg-gray-900 transition duration-300 mr-4`}
  svg {
    ${tw`w-4 h-4`}
  }
`;

export default () => {
  const isRTL = i18n.dir() === "rtl";
  const [loading, setLoading] = useState(false);
  const [branchId, setBranchId] = useState(null);
  const [specialityId, setSpecialityId] = useState(null);
  const [lang, setLang] = useState("العربية");

  const [branchList, setBranchList] = useState([]);
  const [specialityList, setSpecialityList] = useState([]);
  const [doctorsList, setDoctorsList] = useState([]);

  useEffect(() => {
    document.body.dir = i18n.dir();
    document.getElementById("date").valueAsDate = new Date();
  }, []);

  const getBranch = async () => {
    try {
      const response = await fetch(
        "https://tabebek.com/bookAppt/backend/api.php?type=branch"
      );
      const data = await response.json();
      if (data?.success) {
        setBranchList(data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getDoctors = async (sp_id) => {
    try {
      const response = await fetch(
        `https://tabebek.com/bookAppt/backend/api.php?type=doctor&branch_id=${branchId}&speciality_id=${sp_id}`
      );
      const data = await response.json();
      if (data?.success) {
        setDoctorsList(data?.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (branchList?.length === 0) {
      getBranch();
    }
  }, []);

  const handleBranch = (newValue) => {
    setBranchId(newValue);
    setDoctorsList([]);
    const newList = branchList?.filter((item) => item?.id === newValue);
    setSpecialityList(newList[0]?.speciality_list);
  };

  const handleSpeciality = (newValue) => {
    setSpecialityId(newValue);
    getDoctors(newValue);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const {
      branch,
      doctor,
      speciality,
      name,
      phone,
      email,
      id_passport,
      date,
      time,
    } = e.target;
    const url = `https://tabebek.com/bookAppt/backend/api.php?type=book-appt&branch_id=${branch?.value}&speciality_id=${speciality?.value}&doctor_id=${doctor?.value}`;

    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Accept: "*/*",
      },
      body: new URLSearchParams({
        name: name?.value,
        phone: phone?.value,
        email: email?.value,
        national_id: id_passport?.value,
        appt_date: date?.value,
        appt_time: time?.value,
      }),
    };

    const submitApt = async () => {
      try {
        const response = await fetch(url, requestOptions);
        const data = await response.json();
        if (data?.success) {
          toast(data?.message);
          setLoading(false);
        }
      } catch (error) {
        console.log(error);
      }
    };
    if (
      branch?.value !== "" &&
      doctor?.value !== "" &&
      speciality?.value !== "" &&
      name?.value !== "" &&
      phone?.value !== "" &&
      date?.value !== "" &&
      time?.value !== ""
    ) {
      setLoading(true);
      submitApt();
      window.setTimeout(() => window.location.reload(), 2000);
    } else {
      toast(t("fill_text"));
    }
  };

  const handleLang = () => {
    if (i18n.dir() === "rtl") {
      i18next.changeLanguage("en");
      setLang("العربية");
    } else {
      i18next.changeLanguage("ar");
      setLang("English");
    }
    document.body.dir = i18n.dir();
  };

  return (
    <>
      <Header className={"header-light"}>
        <DesktopNavLinks>
          <LogoLink href="#" tw="text-primary-100">
            <img src={logo} alt="logo" />
            <LangButton
              type="button"
              style={{
                alignItems: isRTL ? "center" : "normal",
              }}
              onClick={() => handleLang()}
            >
              {lang}
            </LangButton>
          </LogoLink>
        </DesktopNavLinks>
      </Header>
      <Container>
        <TwoColumn>
          <ImageColumn>
            <Image imageSrc={eradahLogo} />
            <SocialLinksContainer>
              <SocialLink
                href="https://www.facebook.com/0553000043eradah/"
                target="_blank"
              >
                <FacebookIcon />
              </SocialLink>
              <SocialLink
                href="https://twitter.com/eradah_pt?lang=ar"
                target="_blank"
              >
                <TwitterIcon />
              </SocialLink>
              <SocialLink
                href="https://www.instagram.com/eradah_pt/"
                target="_blank"
              >
                <InstagramIcon />
              </SocialLink>
              <SocialLink
                href="https://www.tiktok.com/@eradah2016"
                target="_blank"
              >
                <TikTokIcon />
              </SocialLink>
            </SocialLinksContainer>
            {/* <SocialLinksContainer>
              <b>Call Us:</b> 920031102
            </SocialLinksContainer> */}
          </ImageColumn>
          <TextColumn textOnLeft={true}>
            <TextContent
              style={{
                textAlign: isRTL ? "right" : "left",
              }}
            >
              <LangButton
                type="button"  
                style={{
                  alignItems: "center",
                  width: "6rem",
                  height: "2.5rem",
                }}
                onClick={() => {
                  // i18next.changeLanguage("en");
                  // document.body.dir = "ltr";
                  window.location = "https://www.eradah-pt.com/";
                }}
              >
                {isRTL ? (
                  <ArrowRight
                    style={{
                      width: "1rem",
                      height: "1rem",
                      marginLeft: "5px",
                    }}
                  />
                ) : (
                  <ArrowLeft
                    style={{
                      width: "1rem",
                      height: "1rem",
                      marginRight: "5px",
                    }}
                  />
                )}
                {t("back")}
              </LangButton>
              <Heading
                style={{
                  textAlign: isRTL ? "right" : "left",
                }}
              >
                {t("book_your")}
                <br />
                <span> {t("appt_now")}</span>
              </Heading>
              <Description>{t("book_now_desc")}</Description>
              <Form action="#" method="get" onSubmit={(e) => handleSubmit(e)}>
                <select
                  name="branch"
                  id="branch"
                  className="selectStyle"
                  value={branchId}
                  onChange={(e) => handleBranch(e.target.value)}
                >
                  <option className="optionStyle" value="">
                    {t("select_branch")}
                  </option>
                  {branchList?.map((item) => {
                    return (
                      <option
                        className="optionStyle"
                        key={item?.id}
                        value={item?.id}
                      >
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
                <select
                  name="speciality"
                  id="speciality"
                  disabled={specialityList?.length !== 0 ? false : true}
                  className="selectStyle"
                  value={specialityId}
                  onChange={(e) => handleSpeciality(e.target.value)}
                >
                  <option className="optionStyle" value="">
                    {t("select_spec")}
                  </option>
                  {specialityList?.map((item) => {
                    return (
                      <option
                        className="optionStyle"
                        key={item?.id}
                        value={item?.id}
                      >
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
                <select
                  name="doctor"
                  id="doctor"
                  className="selectStyle"
                  disabled={doctorsList?.length !== 0 ? false : true}
                >
                  <option className="optionStyle" value="">
                    {t("doctor")}
                  </option>
                  {doctorsList?.map((item) => {
                    return (
                      <option
                        className="optionStyle"
                        key={item?.id}
                        value={item?.id}
                      >
                        {item?.name}
                      </option>
                    );
                  })}
                </select>
                <SubHeading
                  style={{
                    textAlign: isRTL ? "right" : "left",
                  }}
                >
                  {t("personal_detail")}
                </SubHeading>
                <Input type="text" name="name" placeholder={t("full_name")} />
                <Input type="tel" name="phone" placeholder={t("phone")} />
                <Input type="email" name="email" placeholder={t("email")} />
                <Input
                  type="text"
                  name="id_passport"
                  placeholder={t("national_id_num")}
                />
                <input
                  type="date"
                  id="date"
                  min={new Date().toISOString().split("T")[0]}
                  name="date"
                  className="selectStyle"
                  style={{
                    position: "relative",
                    width: "100%",
                  }}
                />
                <select name="time" id="time" className="selectStyle">
                  {["Morning", "Evening"]?.map((item, index) => {
                    return (
                      <option className="optionStyle" key={index} value={item}>
                        {item}
                      </option>
                    );
                  })}
                </select>

                <SubmitButton type="submit">
                  {loading ? "loading..." : t("book_now")}
                </SubmitButton>
              </Form>
            </TextContent>
          </TextColumn>
        </TwoColumn>
      </Container>
    </>
  );
};

// console.log({
//   branch: branch?.value,
//   doctor: doctor?.value,
//   speciality: speciality?.value,
//   name: name?.value,
//   phone: phone?.value,
//   email: email?.value,
//   id_passport: id_passport?.value,
//   date: date?.value,
//   time: time?.value,
// });

// const getSpeciality = async () => {
//   try {
//     const response = await fetch(
//       "https://tabebek.com/bookAppt/backend/api.php?type=specaility&branch_id=RTNNdGdCd2NmODIzc2s4OUpqUENZZz09"
//     );
//     const data = await response.json();
//     if (data?.success) {
//       setSpecialityList(data?.data);
//     }
//   } catch (error) {
//     console.log(error);
//   }
// };
